import * as React from "react";

function SvgUser(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={12} cy={9} r={4.5} stroke="#fff" />
      <path
        d="M3.5 21.5v-1a4 4 0 014-4h9a4 4 0 014 4v1"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgUser;
